<script lang="ts">
  import { EventTracking } from "@shared/services/event_tracking/events";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import { ProductEntity, DistributorEntity } from "@shared/services/event_tracking/entities";
  import type { Notice } from "@retailer/svelte/CartWidget/v2/Services/CartItemRequestService";

  export let notice: Notice;
  export let productId: number;
  export let availableToBuy: boolean = false;
  export let distributor;
  export let tooltipPosition: string = "fizz-tooltip-center";
  export let tooltipMaxWidth: string = "300px";

  const { trackMrcEvents } = EventTracking;
  const trackingParams = [
    new ProductEntity({ productId }),
    new DistributorEntity({ id: distributor.id }),
  ];

  // Needed to control when view event fires
  $: tooltipHovered = false;
</script>

<style>
  .tooltip-text {
    border-bottom: 1px dashed #595959;
    font-weight: 400;
  }
</style>

{#if notice.level === "error" && availableToBuy && distributor.allow_ordering_out_of_stock}
  <TrackingContext entities={trackingParams} let:trackingContext>
    <span
      class="fizz-tooltip-container fizz-stack-16"
      data-testid="learn-more-out-of-stock-tooltip"
    >
      <span
        class="tooltip-text fizz-tooltip-trigger fizz-text-subdued"
        aria-describedby="learn-more-tooltip"
        on:mouseenter={() => (tooltipHovered = true)}
        on:mouseleave={() => (tooltipHovered = false)}
      >
        Learn more
      </span>
      {#if tooltipHovered}
        <div
          class={`fizz-tooltip fizz-tooltip-top ${tooltipPosition}`}
          role="tooltip"
          id="learn-more-tooltip"
          use:trackMrcEvents={[trackingContext.entities]}
          style={`--min-width: 100px; --max-width: ${tooltipMaxWidth};`}
        >
          This distributor allows you to order out of stock items, in the event they’re restocked by
          the time of fulfillment.
        </div>
      {/if}
    </span>
  </TrackingContext>
{/if}
